import { useFetch } from "@common/hooks/useFetch";
import { useContext } from "react";
import { NumberOfferContext } from "../App";
import { ICart } from "@features/cart/ICart";
import { getProspectId } from "@utils/storage";
import { addOfferRoute, addOfferCrossSellRoute } from "@api-routes";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { getStateToPayload } from "@mappers/postOfferMapper";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useAddOffer = () => {
    const [addOfferState, { post }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const addOffer = (
        catalogOfferCode: string,
        catalogTariffPlanCode: string,
        portIn: boolean,
        prospectId?: string
    ): Promise<ICart | undefined> => {
        const prospect = prospectId ?? getProspectId();

        return post<ICartResponse>(
            keycloakUtils.isAuthenticated() ? addOfferCrossSellRoute(prospect) : addOfferRoute(prospect),
            {
                body: getStateToPayload(catalogOfferCode, catalogTariffPlanCode, portIn),
                isSecured: keycloakUtils.isAuthenticated(),
            }
        ).then((newCartResponse) => {
            if (newCartResponse) {
                const newCart = getResponseToState(newCartResponse);

                setNumberOfferSelected(newCart.offers.length);

                return newCart;
            }

            return undefined;
        });
    };

    return { addOfferState, addOffer };
};
